import {
    Header,
    SidePanels,
    CardProduct,
    MiniCart,
    CollapsibleCard,
    GridCards,
    NavigationPage,
    BlogPost,
    HorizontalScroller,
    AccountNav,
    Address,
    TeamCards,
    Blog,
    SortBlog,
    Product,
    ProductSections,
    StatsCarousel,
    InfoCarousel,
    InfoSlider,
    ScrollAnimation,
    KlaviyoPopup,
    CustomReviews,
    ShowMore,
    CustomTestimonials,
    CardsReviews,
    FeaturedCollections,
    Marquee,
    ImageTextCarousel,
    HeroCarousel
} from "./scripts/components";
import { selectDoc } from "./scripts/utils/utils";

(function () {
  new SidePanels(selectDoc("#shopify-section-header"));
  new Header(selectDoc("#shopify-section-header"));
  new CardProduct(selectDoc(".card-product"));
  new MiniCart(selectDoc(".collection-grid, .featured-collections"));
  new CollapsibleCard(selectDoc(".collapsible-cards"));
  new HorizontalScroller();
  new GridCards(selectDoc(".grid-cards"));
  new NavigationPage(selectDoc(".navigation-page"));
  new BlogPost(selectDoc(".article"));
  new AccountNav(selectDoc(".js-account"));
  new Address(selectDoc(".js-account"));
  new TeamCards(selectDoc("[data-team-carousel]"));
  new Blog(selectDoc(".main-blog-template"));
  new SortBlog(selectDoc("[data-blog-filters]"));
  new Product(selectDoc("[data-product]"));
  new ProductSections(selectDoc("[data-product]"));
  new StatsCarousel(selectDoc("[data-stats-carousel]"));
  new InfoCarousel(selectDoc("[data-nad]"));
  new InfoSlider(selectDoc("[data-slider]"));
  new ScrollAnimation(selectDoc(".main-index-template, .main-page-template"));
  new KlaviyoPopup(selectDoc(".main-product-template, .main-collection-template"));
  new CustomReviews(selectDoc(".main-index-template, .main-product-template, .main-collection-template"));
  new ShowMore(selectDoc('.main-index-template, .main-product-template, .main-collection-template'));
  new CustomTestimonials(selectDoc(".main-product-template, .main-collection-template"));
  new CardsReviews(selectDoc(".main-product-template, .main-collection-template"));
  new FeaturedCollections(selectDoc('.main-index-template, .body-page-template'));
  new Marquee(selectDoc('.main-index-template'));
  new FeaturedCollections(selectDoc('.main-index-template'));
  new ImageTextCarousel(selectDoc('[data-image-text-carousel]'));
  new HeroCarousel(selectDoc('[data-hero-carousel]'));
})();
